import {
  SEND_MAIL,
  GET_CONVERSATION_DATA,
  GET_CONVERSATION,
  ADD_MESSAGE_TO_CONVERSATION,
  SEND_NOTE,
  MOVE_CONVERSATION_TO,
  PUT_CONVERSATION,
  DELETE_CONVERSATION,
  SNOOZE_CONVERSATION,
  UPDATE_CONVERSATION_AND_REFRESH,
  DELETE_MSG_OF_CONVERSATION,
  GET_SERACHED_CONVERSATION_DATA,
  MERGE_CONVERSATION,
  SPLIT_CONVERSATION,
  GET_USER_TEMPLATES,
  GET_SINGLE_TEMPLATE,
  MASS_ACTION,
  UPDATE_INBOX,
  ADD_INBOX,
  INBOX_COUNTS,
  GET_SEARCHED_ARTICLES,
  GET_STATUS_LIST,
  CREATE_TICKET,
  GET_USER_ROLES,
  GET_SMS_CHANNEL_LIST,
  GET_SMS_SINGLE,
  UPDATE_SMS,
  DELETE_SMS,
  ADD_SMS_CHANNEL,
  GET_PHONE_NUMBER,
  GET_SHARED_SECRET_KEY,
  GET_ARTICLES_BY_CONVERSATION,
  SEND_VERIFICATION_MAIL_INBOX,
  ADD_GMAIL_INBOX,
  GENERATE_OPEN_AI_MESSAGE,
  MODIFY_OPEN_AI_EMAIL_REPLY,
  GET_ALL_MAIL_INBOX,
} from './types'
import {apiAction} from './api'
import * as endpoint from './endpoint'

// Get all Inbox //

export function createTicket(data) {
  return apiAction({
    url: `${endpoint.DESK_CONVERSATIONS}/ticket`,
    method: 'POST',
    label: CREATE_TICKET,
    data,
    showToast: true,
    successMessage: 'Ticket Created',
  })
}

export function getAllMailInbox(data) {
  return apiAction({
    url: endpoint.DESK_MAILBOXES,
    method: 'GET',
    label: GET_ALL_MAIL_INBOX,
    params: data,
  })
}

// Add Inbox
export function addInbox(data) {
  return apiAction({
    url: endpoint.DESK_MAILBOXES,
    method: 'POST',
    label: ADD_INBOX,
    data,
    showToast: true,
    successMessage: 'Inbox Created',
  })
}

export function addGmailInbox(data) {
  return apiAction({
    url: `${endpoint.DESK_EMAIL_INTEGRATION}/google/connect`,
    method: 'POST',
    label: ADD_GMAIL_INBOX,
    data,
  })
}

// Update Inbox

export function updateInbox(data, id) {
  return apiAction({
    url: `${endpoint.DESK_MAILBOXES}/${id}/settings`,
    method: 'PUT',
    label: UPDATE_INBOX,
    data,
    showToast: true,
    successMessage: 'Inbox Updated',
  })
}

// Delete INbox
export function deleteInbox(data) {
  return apiAction({
    url: `${endpoint.DESK_MAILBOXES}/${data}`,
    method: 'DELETE',
    label: 'DELETE_INBOX',
    showToast: true,
    successMessage: 'Inbox Deleted',
  })
}

export function assignInbox(data) {
  return apiAction({
    url: `${endpoint.DESK_MAILBOXES}/assign`,
    method: 'POST',
    label: 'ASSIGN_INBOX',
    data,
  })
}

export function sendVerificationMailInbox(id) {
  return apiAction({
    url: `${endpoint.DESK_MAILBOXES}/${id}/sendverificationmail`,
    method: 'POST',
    label: SEND_VERIFICATION_MAIL_INBOX,
    showToast: true,
    successMessage: 'Invitation sent to your email for forwarding',
  })
}

export function sendEmail(data, toastMsg) {
  return apiAction({
    url: endpoint.DESK_CONVERSATIONS,
    method: 'POST',
    label: SEND_MAIL,
    data,
    showToast: true,
    successMessage: toastMsg || 'Email Sent',
  })
}

export function sendNote(data) {
  return apiAction({
    url: `${endpoint.DESK_CONVERSATIONS}/notes`,
    method: 'POST',
    label: SEND_NOTE,
    data,
    showToast: true,
    successMessage: 'Note Added',
  })
}

export function addMessageToConversation(data, conversationId, toastMsg) {
  return apiAction({
    url: `${endpoint.DESK_CONVERSATIONS}/${conversationId}/messages`,
    method: 'POST',
    label: ADD_MESSAGE_TO_CONVERSATION,
    data,
    showToast: !!toastMsg,
    successMessage: toastMsg,
  })
}

export function deleteMessageOfConversation(conversationId, messageId) {
  return apiAction({
    url: `${endpoint.DESK_CONVERSATIONS}/${conversationId}/messages/${messageId}`,
    method: 'DELETE',
    label: DELETE_MSG_OF_CONVERSATION,
    showToast: true,
    successMessage: 'Msg Deleted',
  })
}

export function moveConversationTo(data) {
  return apiAction({
    url: `${endpoint.DESK_CONVERSATIONS}/mailbox`,
    method: 'POST',
    label: MOVE_CONVERSATION_TO,
    data,
    showToast: true,
    successMessage: 'Conversation Moved',
  })
}

export function getMailBoxConversation(params) {
  const keys = Object.keys(params || {})

  const query = keys
    .filter(key => params[key])
    .map(key => `${key}=${params[key]}`)
    .join('&')

  return apiAction({
    url: `${endpoint.DESK_CONVERSATIONS}?${query}`,
    method: 'GET',
    label: GET_CONVERSATION_DATA,
  })
}

export function getSearchedMailBoxConversation(data) {
  const keys = Object.keys(data)

  let url = `${endpoint.DESK_CONVERSATIONS}?`

  for (let i = 0; i < keys.length; i += 1) {
    const key = keys[i]
    url += `${key}=${data[key]}`
  }

  return apiAction({
    url,
    method: 'GET',
    label: GET_SERACHED_CONVERSATION_DATA,
  })
}

export function getConversation(id) {
  const url = `${endpoint.DESK_CONVERSATIONS}/${id}`

  return apiAction({
    url,
    method: 'GET',
    label: GET_CONVERSATION,
  })
}

export function updateConversation(data, type) {
  const url = `${endpoint.DESK_CONVERSATIONS}/update`

  return apiAction({
    url,
    method: 'POST',
    label: PUT_CONVERSATION,
    data,
    showToast: !!type,
    successMessage: `${type} Updated`,
    successData: type,
  })
}

export function updateConversationPriority(data, type) {
  const url = `${endpoint.DESK_CONVERSATIONS}/priority`

  return apiAction({
    url,
    method: 'PUT',
    label: PUT_CONVERSATION,
    data,
    showToast: true,
    successMessage: `${type} Updated`,

    successData: type,
  })
}

export function updateConversationStatus(data, type) {
  const url = `${endpoint.DESK_CONVERSATIONS}/status`

  return apiAction({
    url,
    method: 'PUT',
    label: PUT_CONVERSATION,
    data,
    showToast: true,
    successMessage: `${type} Updated`,

    successData: type,
  })
}

// ---migration pending---//
export function permanentDeleteConversation(data) {
  const url = endpoint.DESK_CONVERSATIONS
  const params = data.conversationIds.join(',')
  return apiAction({
    url: `${url}/${params}`,
    method: 'DELETE',
    label: DELETE_CONVERSATION,
    showToast: true,
    successMessage: 'Conversation Deleted',
  })
}

export function updateConversationAndRefresh(data, type) {
  const url = `${endpoint.DESK_CONVERSATIONS}/update`

  return apiAction({
    url,
    method: 'POST',
    label: UPDATE_CONVERSATION_AND_REFRESH,
    data,
    successData: type,
    showToast: !!type,
    successMessage: type,
  })
}

export function snoozeConversation(data, conversationId) {
  const url = `${endpoint.DESK_CONVERSATIONS}/${conversationId}/snooze`

  return apiAction({
    url,
    method: 'PUT',
    label: SNOOZE_CONVERSATION,
    data,
    showToast: true,
    successMessage: 'Snooze Updated',
  })
}

export function mergeConversation(data) {
  const url = `${endpoint.DESK_CONVERSATIONS}/merge`

  return apiAction({
    url,
    method: 'POST',
    label: MERGE_CONVERSATION,
    data,
    showToast: true,
    successMessage: 'Conversation Merged',
  })
}

export function splitConversation(data, conversationId) {
  const url = `${endpoint.DESK_CONVERSATIONS}/${conversationId}/split`

  return apiAction({
    url,
    method: 'POST',
    label: SPLIT_CONVERSATION,
    data,
    showToast: true,
    successMessage: 'Conversation splited',
  })
}

export function GetArticlesByConversation(id) {
  return apiAction({
    url: `${endpoint.DESK_CONVERSATIONS}/releventarticles/${id}`,
    method: 'GET',
    label: GET_ARTICLES_BY_CONVERSATION,
  })
}

export function GetSearchedArticles(text) {
  return apiAction({
    url: `${endpoint.DOCS}/article/attachArticle?text=${text}`,
    method: 'GET',
    label: GET_SEARCHED_ARTICLES,
  })
}

export function getUserTemplates() {
  const url = `${endpoint.DESK_DESK}/templates`

  return apiAction({
    url,
    method: 'GET',
    label: GET_USER_TEMPLATES,
  })
}

export function singleUserTemplates(id, conversationId) {
  const params = conversationId ? `?conversationId=${conversationId}` : ''

  return apiAction({
    url: `${endpoint.DESK_DESK}/templates/${id}${params}`,
    method: 'GET',
    label: GET_SINGLE_TEMPLATE,
  })
}

export function massAction(data, toastMsg) {
  return apiAction({
    url: `${endpoint.DESK_CONVERSATIONS}/massaction`,
    method: 'PUT',
    label: MASS_ACTION,
    showToast: true,
    successMessage: toastMsg || 'Mass Updated',
    data,
  })
}

export function inboxCounts() {
  return apiAction({
    url: `${endpoint.DESK_CONVERSATIONS}/counts`,
    method: 'GET',
    label: INBOX_COUNTS,
  })
}

export function getStatusList() {
  return apiAction({
    url: `${endpoint.DESK_CONVERSATIONS}/statuses`,
    method: 'GET',
    label: GET_STATUS_LIST,
  })
}

export function getUserRoles() {
  return apiAction({
    url: `${endpoint.USER_USERS}/roles`,
    method: 'GET',
    label: GET_USER_ROLES,
  })
}

export function getSMSList() {
  return apiAction({
    url: `${endpoint.DESK_CHANNEL_V1}/sms`,
    method: 'GET',
    label: GET_SMS_CHANNEL_LIST,
  })
}

export function getSMSSingle(id) {
  return apiAction({
    url: `${endpoint.DESK_CHANNEL_V1}/sms/${id}`,
    method: 'GET',
    label: GET_SMS_SINGLE,
  })
}

export function updateSMS(id, data) {
  return apiAction({
    url: `${endpoint.DESK_CHANNEL_V1}/sms/${id}`,
    method: 'PUT',
    label: UPDATE_SMS,
    data,
    successMessage: 'SMS Channel Updated',
  })
}

export function deleteSMS(id) {
  return apiAction({
    url: `${endpoint.DESK_CHANNEL_V1}/${id}`,
    method: 'DELETE',
    label: DELETE_SMS,
    successMessage: 'SMS Channel Deleted',
  })
}

export function addSmsChannel(data) {
  return apiAction({
    url: `${endpoint.DESK_CHANNEL_V1}/sms`,
    method: 'POST',
    label: ADD_SMS_CHANNEL,
    data,
    showToast: true,
    successMessage: 'SMS Channel Added',
  })
}

export function getPhoneNumberSMS(data) {
  return apiAction({
    url: `${endpoint.DESK_CHANNEL_V1}/sms/incomingphonenumber`,
    method: 'GET',
    label: GET_PHONE_NUMBER,
    params: data,
    showToast: true,
  })
}

export function getSharedSecretKey() {
  return apiAction({
    url: `${endpoint.DESK_CHANNEL_V1}/sms/sharedsecret`,
    method: 'GET',
    label: GET_SHARED_SECRET_KEY,
    showToast: true,
  })
}

export function generateOpenAiMessage(data) {
  return apiAction({
    url: `${endpoint.DESK_CONVERSATIONS}/help-me-write`,
    method: 'POST',
    label: GENERATE_OPEN_AI_MESSAGE,
    data,
  })
}

export function modifyOpenAiEmailReply(data) {
  return apiAction({
    url: `${endpoint.OPENAI_ENDPOINT}/modify-email-reply`,
    method: 'POST',
    label: MODIFY_OPEN_AI_EMAIL_REPLY,
    data,
  })
}
